import { memo, ReactNode, useCallback, useContext } from 'react'
import cn from 'classnames'

import { TabContext } from './components/TabContext'

interface IProps {
  children: ReactNode
  tabId: string
  className?: string
}

const Tab = memo(function Tab({ className, tabId, ...props }: IProps) {
  const { currentTab, setCurrentTab } = useContext(TabContext)

  const handleSetCurrentTab = useCallback(() => {
    setCurrentTab(tabId)
  }, [setCurrentTab, tabId])

  return (
    <div
      onClick={handleSetCurrentTab}
      className={cn(
        'root cursor-pointer px-0 pb-2 pt-0 text-on-surface [&+root]:ml-4',
        'hover:text-primary',
        className,
        {
          'cursor-default border-b-2 border-solid border-b-primary': currentTab === tabId
        }
      )}
      {...props}
    />
  )
})

export default Tab
